module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNCIgZGF0YS1uYW1lPSJHcm91cCA0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4NCiAgPGNpcmNsZSBpZD0iT3ZhbF82IiBkYXRhLW5hbWU9Ik92YWwgNiIgY3g9IjEzIiBjeT0iMTMiIHI9IjEzIiBmaWxsPSJyZ2JhKDAsMTE2LDI1NSwwLjE2KSIvPg0KICA8Y2lyY2xlIGlkPSJPdmFsXzYtMiIgZGF0YS1uYW1lPSJPdmFsIDYiIGN4PSI3IiBjeT0iNyIgcj0iNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA2KSIgZmlsbD0iIzAwNzRmZiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./static/icon/landian.svg
// module id = qWdf
// module chunks = 1